import { TableColumn } from '../../model';

export type NestedTableColumn<C extends string> = Omit<
  TableColumn<unknown>,
  'id' | 'render'
> & {
  id: C;
};
